/**
 * Ryan O'Dowd
 * 2022-12-29
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  const text = {
    fontFamily: fonts.primaryBold,
    textAlign: 'center',
  };

  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: globalScale * 8,
    },
    errorText: {
      ...text,
      color: colors.alertLight,
    },
    successText: {
      ...text,
      color: colors.accent,
    },
  };
};

export default getStyles;
